<template>
    <card-list-item @click="$emit('click')" :class="{'active': active}">
        <template v-slot:icon>
            <i class="fas fa-user"></i>
        </template>
        <template v-slot:content>
            <div class="tile-title">{{ user.last_name }}, {{ user.first_name }}</div>
            <div class="meta">{{ user.courses_started }} courses started</div>
            <div class="meta">{{ user.courses_completed }} courses completed</div>
        </template>
        <template v-slot:status>
            <div class="stats">
                <div class="stat">{{ user.total_hours }} total hours</div>
                <div class="stat">{{ user.total_courses }} total courses</div>
            </div>
        </template>
        <template v-slot:details>
            <div style="margin-top: 0.5rem">
                <div class="data mt-1">
                    <data-row mini title="Registration Date">{{ moment(user.created_at).format('MMMM D, YYYY') }}</data-row>
                    <data-row mini title="Phone">{{ user.phone }}</data-row>
                    <data-row mini title="Grade, Subject">{{ user.grade_level ? `${user.grade_level}, ` : `` }}{{ user.subject_area }}</data-row>
                    <data-row mini title="School/District">{{ user.school }}, {{ user.district }}</data-row>
                    <data-row mini title="Courses Started">{{ user.courses_started }}</data-row>
                    <data-row mini title="Courses Completed">{{ user.courses_completed }}</data-row>
                </div>
            </div>
        </template>
    </card-list-item>
</template>

<script>
// tier
import CardListItem from "@/TIER/components/CardListItem";
import DataRow from "@/TIER/components/DataRow";
import Toolbar from "@/TIER/components/Toolbar";
// js
import moment from "moment";

export default {
    name: 'ResellerClientTile',
    components: { CardListItem, DataRow, Toolbar },
    props: {
        card: {
            required: true
        },
        user: {
            type: Object,
            required: true
        },
        active: {
            type: Boolean,
            default: false
        }
    },
    data: function () {
        return {
            moment,
        }
    },
    methods: {
        openCard: function (card, props) {
            this.$openCard(card, props, this.card);
        },
    }
}
</script>

<style lang="scss" scoped>
.tile-title {
    font-size: 0.9rem;
    font-weight: bold;
}

.tile-details {
    margin-top: 0.5rem;
}
</style>
